import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { deleteWebSocketManager } from '../webSocket/webSocketCache';
const ReloadInstanceContext = createContext({
    reloadInstance: () => {
        throw new Error('ReloadInstanceContext not provided');
    }
});
export const ReloadInstanceProvider = ({ instanceId, numInstances, existingReloadInstance, children }) => {
    const [isRendered, setIsRendered] = useState(true);
    const value = useMemo(() => ({
        reloadInstance: existingReloadInstance ||
            (() => {
                if (numInstances === 1) {
                    window.location.reload();
                }
                else {
                    deleteWebSocketManager(instanceId);
                    setIsRendered(false);
                }
            })
    }), [existingReloadInstance, instanceId, numInstances]);
    useEffect(() => {
        if (!isRendered) {
            // trigger re-mounting of the app after it was unmounted to make sure instance's entire state gets reset:
            setIsRendered(true);
        }
    }, [isRendered]);
    if (!isRendered) {
        return null;
    }
    return _jsx(ReloadInstanceContext.Provider, { value: value, children: children });
};
export function useReloadInstance() {
    const { reloadInstance } = useContext(ReloadInstanceContext);
    return reloadInstance;
}
